import React from 'react';

import { Modal, useModal } from 'components/complex/Modal';
import MenuItems from 'components/layouts/Header/MenuItems';
import Logo from 'components/layouts/Header/img/logo.svg';

import s from './MobileMenuModal.module.scss';

export const MobileMenuModal: React.FC = () => {
  const { modalProps } = useModal({
    type: 'MobileMenu',
    width: '368px',
  });

  return (
    <Modal isFillSize {...modalProps} className={s.wrapper}>
      <>
        <Logo className={s.logo} />

        <MenuItems />
      </>
    </Modal>
  );
};
